import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs';

import { EventService } from '../event/event.service';

export const eventGuard: CanActivateFn = () => {
  const eventService = inject(EventService);
  return eventService.getActive().pipe(map(activeEvent => activeEvent !== undefined));
};
